<template>
    <div v-if="!session.is_completed">
        {{ $t("virtual_visit:start_a_call:description") }}:
        <a class="btn btn-default btn-xs" @click="inviteClientViaSMS()">{{ $t("virtual_visit:send_sms:btn") }}</a>
        {{ $t("general:or") }}
        <a class="btn btn-default btn-xs" @click="inviteClientViaEmail()">{{ $t("virtual_visit:send_email:btn") }}</a>.
        {{ $t("virtual_visit:sms_email_verification:description") }}
    </div>
</template>

<script>
import ApiService from '@/components/utils/api.service.js';
import Swal from "sweetalert2";
import { Swal as showSwal } from "@/components/utils/swal.alerts.js";

export default {
    props: {
        session: {
            type: Object,
            required: true
        },
    },
    data: function () {
        return {}
    },
    methods: {
        inviteClientViaEmail: function () {
            let msg = `
            <br>
            ${this.$t("virtual_visit:send_email:content").replace("\n", "<br>")}
            <br><br>
            ${this.clientUrl}
            <br><br>
            ${this.$t("virtual_visit:send_email:greeting")}.
            `
            showSwal({
                title: this.$t("virtual_visit:send_message:description"),
                html: msg,
                confirmButtonText: this.$t("general:close"),
            })
        },
        inviteClientViaSMS: function () {
            const app = this;
            showSwal({
                title: this.$t("virtual_visit:send_sms:btn"),
                text: this.$t("virtual_visit:send_sms:description"),
                input: "text",
                inputLabel: this.$t("virtual_visit:phone_number"),
                inputPlaceholder: "+38631456789",
                confirmButtonText: this.$t("general:send:btn"),
                showCancelButton: true,
                cancelButtonText: this.$t("general:cancel:btn"),
                inputValidator: (value) => {
                    if (!value) {
                        return this.$t("virtual_visit:phone_number:missing");
                    }
                },
                preConfirm: (mobile) => {
                    Swal.showLoading(); // Show loader
                    return ApiService
                        .post(`/virtual-visit/api/virtual-session/${app.session.id}/send-invite-client-sms`, { mobile })
                        .then(response => {
                            Swal.hideLoading && Swal.hideLoading(); // Hide loader if available
                            if (response.data.status === "FAILED") {
                                app.notify(app.$t("virtual_visit:send_sms:not_sent"), app.$t("virtual_visit:send_sms:error:general"), "warn");
                                throw new Error(app.$t("virtual_visit:send_sms:error:general"));
                            } else if (response.data.status === "INVALID") {
                                app.notify(app.$t("virtual_visit:send_sms:not_sent"), app.$t("virtual_visit:send_sms:error:invalid_number"), "warn");
                                throw new Error(app.$t("virtual_visit:send_sms:error:invalid_number"));
                            } else {
                                app.notify("SMS sent", "", "success");
                            }
                        })
                        .catch(error => {
                            Swal.hideLoading && Swal.hideLoading(); // Hide loader if available
                            let msg = app.$t("virtual_visit:send_sms:error:general");
                            if (error.response && error.response.status === 403) {
                                msg = app.$t("virtual_visit:send_sms:error:no_permissions");
                            } else if (error.response && error.response.status === 400) {
                                msg = app.$t("virtual_visit:send_sms:error:invalid_number");
                            }
                            app.notify(app.$t("virtual_visit:send_sms:not_sent"), msg, "warn");
                            throw new Error(msg);
                        })
                },
            });
        },
        // ------------------------------
        // Utils
        // ------------------------------
        notify: function (title = "", text = "", type = "info") {
            this.$notify({
                group: "OTwarnings",
                type: type,
                title: title,
                text: text
            });
        },
    },
    computed: {
        clientUrl() {
            if (!this.session) { return ; }
            return this.session.client_url_full;
        },
    }
}
</script>
